import { TextField } from "@mui/material";
import { FC } from "react";
import { Control, Controller } from "react-hook-form";

import { CryptorFormData } from "@/pages/cryptor/utils/cryptor.schema";

interface CryptorDescriptionFieldProps {
  control: Control<CryptorFormData, {}>;
}

const CryptorDescriptionField: FC<CryptorDescriptionFieldProps> = ({
  control,
}) => {
  return (
    <Controller
      control={control}
      name="description"
      render={({ field, fieldState }) => (
        <TextField
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Description"
          value={field.value}
          onChange={field.onChange}
          margin="normal"
          error={fieldState.invalid}
          fullWidth
        />
      )}
    />
  );
};

export default CryptorDescriptionField;
